var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      _c("LoginWorldWide", {
        attrs: {
          linkClass: "test-statusLogin--blue",
          label: _vm.label,
          logoutUrl: _vm.logoutUrl,
          myAccount: _vm.myAccount,
          myDataUrl: _vm.myDataUrl,
          username: _vm.firstName + " " + _vm.lastName,
          state: _vm.state
        }
      }),
      _vm._v(" "),
      _vm.state === "loggedIn"
        ? _c("li", { staticClass: "hidden-xs" }, [
            _c("span", { staticClass: "space" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.state === "loggedOut"
        ? _c("li", { staticClass: "sub worldwideLink" }, [
            _c(
              "a",
              {
                staticClass: "test-statusLogin--blue",
                attrs: { href: _vm.loginUrl, title: "Login" }
              },
              [_vm._v("\n      Login\n    ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.state === "loggedOut"
        ? _c("li", { staticClass: "hidden-xs" }, [
            _c("span", { staticClass: "space" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.state === "loggedOut"
        ? _c("li", { staticClass: "sub worldwideLink" }, [
            _c(
              "a",
              {
                staticClass: "test-statusLogin--blue",
                attrs: { href: _vm.registerUrl, title: "Register" }
              },
              [_vm._v("\n      Register\n    ")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.state === "loggedOut"
        ? _c("li", { staticClass: "hidden-xs" }, [
            _c("span", { staticClass: "space" })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }